import _mapValues from 'lodash/mapValues'
import _uniqueId from 'lodash/uniqueId'
import keyMirror from 'keymirror'

const ORG_SETTINGS_CONSTANTS = keyMirror({
  ORG_SETTINGS_UPDATED: null,

  UPLOAD_ORG_LOGO_STARTED: null,
  UPLOAD_ORG_LOGO_FINISHED: null,
  UPLOAD_ORG_LOGO_FAILED: null,

  UPLOAD_WIDGET_ICON_STARTED: null,
  UPLOAD_WIDGET_ICON_FINISHED: null,
  UPLOAD_WIDGET_ICON_FAILED: null,
})

export default _mapValues(ORG_SETTINGS_CONSTANTS, _uniqueId)



// WEBPACK FOOTER //
// ./src/scripts/constants/OrgSettingsConstants.js